angular.module('webtrader').component('barometer', {
  bindings: {
    symbol: '=',
    high: '=',
    low: '=',
  },
  templateUrl: BASE_URL+'templates/component.barometer.html',
  controller: function ($scope, $http, Account) {
    // let updateData = () => {
    //   this.highPercent = this.lowPercent = null
    //   $http.get(`${Account.BASE_URL}/trade/global_stats/`, {
    //     params: {
    //       symbol: this.symbol
    //     }
    //   }).then((res) => {
    //     this.highPercent = res.data[this.high]
    //     this.lowPercent = res.data[this.low]
    //   })
    // }
    //
    // let symbol = this.symbol;
    //  updateData()
    // Object.defineProperty(this, 'symbol', {
    //   get: () => symbol,
    //   set: (val) => {
    //     symbol = val
    //     updateData()
    //   }
    // })
  }
})